import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import ExceptionCategoryAddEdit from "./ExceptionCategoryAddEdit";
import ExceptionCategoryTable from "./ExceptionCategoryTable";

function ExceptionCategoryTableContainer(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/edit/:id`}>
          <ExceptionCategoryAddEdit />
        </Route>
        <Route path={`${path}/add`}>
          <ExceptionCategoryAddEdit />
        </Route>
        <Route path={`${path}`}>
          <ExceptionCategoryTable />
        </Route>
      </Switch>
    </>
  );
}

export default ExceptionCategoryTableContainer;
